import { combineReducers } from 'redux';
import { put, takeEvery } from 'redux-saga/effects';
import prepareBody from '../utils/prepareBody';
import { GET_RACE } from './race';
import { clearError } from './signup';
import { FETCH_THEME, FETCH_THEME_SUCCESS, FETCH_THEME_FAILURE } from './theme';

export const OPEN_PLANS_MODAL = 'landing/OPEN_PLANS_MODAL';
export const CLOSE_PLANS_MODAL = 'landing/CLOSE_PLANS_MODAL';
export const OPEN_LOGIN_MODAL = 'landing/OPEN_LOGIN_MODAL';
export const CLOSE_LOGIN_MODAL = 'landing/CLOSE_LOGIN_MODAL';
export const OPEN_VIP_MODAL = 'landing/OPEN_VIP_MODAL';
export const CLOSE_VIP_MODAL = 'landing/CLOSE_VIP_MODAL';
export const OPEN_LOGIN_SECTION = 'landing/OPEN_LOGIN_SECTION';
export const OPEN_FORGOT_PASS_SECTION = 'landing/OPEN_FORGOT_PASS_SECTION';
export const LANDING_CONTACT_US = 'landing/CONTACT_US';
export const LANDING_CONTACT_US_SUCCESS = 'landing/CONTACT_US_SUCCESS';
export const LANDING_CONTACT_US_FAILURE = 'landing/CONTACT_US_FAILURE';
export const CLOSE_CONTACT_SUCCESS_MODAL = 'landing/CLOSE_CONTACT_SUCCESS_MODAL';
export const RESET_PASS = 'landing/RESET_PASS';
export const RESET_PASS_SUCCESS = 'landing/RESET_PASS_SUCCESS';
export const RESET_PASS_FAILURE = 'landing/RESET_PASS_FAILURE';
export const CLEAR_RESET_PASS_ERROR = 'landing/CLEAR_RESET_PASS_ERROR';
export const TOGGLE_END_NYRR_MODAL = 'landing/TOGGLE_END_NYRR_MODAL';
export const REDIRECT_TO_LANDING = 'landing/REDIRECT_TO_LANDING';
export const CLEAR_REDIRECT_TO_LANDING = 'landing/CLEAR_REDIRECT_TO_LANDING';

export const defaultData = {
    landingSlider: ['/img/slider1.jpg', '/img/slider2.jpg', '/img/slider3.jpg'],
    landingBannerFooter: '/img/slider1.jpg',
    landingDescription: 'Whether you are a seasoned vet or tackling your first marathon, RUNtrix guides your training. Our unique training plans and coaching are the difference between running alone or training with confidence.',
    landingHeader: 'Embrace the Journey to the Finish Line',
    landingLogo: '/img/run-trix-logo@2x.png',
    section1: {
        title: 'Personalized Training Plan',
        description: `You are not the pack. So why follow a generic training plan that’s not personalized for you?
        At RUNtrix, we believe your training journey is a personal experience so we adapt your training plan as you run and log your progress.`,
    },
    section2: {
        title: 'Start to Finish',
        description: `Keep an eye on the finish line by crushing each week of workouts in your training plan.
        RUNtrix delivers fresh workouts every week to make sure you don’t fall into a training rut. Look ahead at upcoming workouts and log your training all in one place.`,
    },
    section3: {
        title: 'Expert Coaching',
        description: `No more tired pdf’s. Receive pro-caliber coaching with an option for additional one-on-one attention and support through E-coaching.
Our coaches combine the science and art of running to give you an edge on race day.`,
    },
    testemonials: {
        header: 'Join over 10,000 runners who have embraced their marathon training journeys using RUNtrix',
        testemonial1: {
            title: 'Amy, 40 yrs',
            description: 'I have used RUNtrix for numerous races over the past few years and it by far exceeds any other online training program available… Every runner from the novice to the elite would no doubt benefit from training with RUNtrix.',
            image: '/img/amy@2x.png',
        },
        testemonial2: {
            title: 'Rich, 39 yrs',
            description: 'Without the guidance of RUNtrix, I wouldn’t have had the confidence to tackle my first half marathon. I not only achieved my goal but I surpassed it and couldn’t have been happier.',
            image: '/img/rich@2x.png',
        },
        testemonial3: {
            title: 'Brendon, 27 yrs',
            description: 'With RUNtrix, I qualified for Boston twice and set my personal bests in the half and full marathon. Bottom line, If you want to have the luxury of an e-coach without the high costs, this program is for you.',
            image: '/img/brendan@2x.png',
        },
    },
    landingVideo: '//www.youtube.com/embed/tnBQmEqBCY0',
};

const mapStateFromTheme = result => ({
    landingSlider: [
        result[1]['Landing Page'].Landing_banner1,
        result[1]['Landing Page'].Landing_banner2,
        result[1]['Landing Page'].Landing_banner3,
    ],
    landingBannerFooter: result[1]['Landing Page'].Landing_banner_footer,
    landingDescription: result[1]['Landing Page'].Landing_description,
    landingHeader: result[1]['Landing Page'].Landing_header,
    landingLogo: result[1]['Landing Page'].Landing_logo,
    landingModalText: result[1]['Landing Page'].Login_modal_text,
    section1: {
        title: result[1]['Landing Page'].Landing_section1_title,
        description: result[1]['Landing Page'].Landing_section1_description,
    },
    section2: {
        title: result[1]['Landing Page'].Landing_section2_title,
        description: result[1]['Landing Page'].Landing_section2_description,
    },
    section3: {
        title: result[1]['Landing Page'].Landing_section3_title,
        description: result[1]['Landing Page'].Landing_section3_description,
    },
    section4: {
        title: result[1]['Landing Page'].Landing_section4_title,
        description: result[1]['Landing Page'].Landing_section4_description,
    },
    testemonials: {
        header: result[1]['Landing Page'].Landing_testimonial_he,
        testemonial1: {
            title: result[1]['Landing Page'].Landing_testimonial1_title,
            description: result[1]['Landing Page'].Landing_testimonial1_description,
            image: result[1]['Landing Page'].Landing_testimonial1_image,
        },
        testemonial2: {
            title: result[1]['Landing Page'].Landing_testimonial2_title,
            description: result[1]['Landing Page'].Landing_testimonial2_description,
            image: result[1]['Landing Page'].Landing_testimonial2_image,
        },
        testemonial3: {
            title: result[1]['Landing Page'].Landing_testimonial3_title,
            description: result[1]['Landing Page'].Landing_testimonial3_description,
            image: result[1]['Landing Page'].Landing_testimonial3_image,
        },
    },
    landingVideo: result[1]['Landing Page'].Landing_video,
});

export function plansModalOpened(state = false, action) {
    switch (action.type) {
        case OPEN_PLANS_MODAL:
            return true;
        case CLOSE_PLANS_MODAL:
            return false;
        default:
            return state;
    }
}

export function contactSuccessModal(state = false, action) {
    switch (action.type) {
        case LANDING_CONTACT_US_SUCCESS:
            return true;
        case CLOSE_CONTACT_SUCCESS_MODAL:
            return false;
        default:
            return state;
    }
}

export function resetPassReducer(state = {
    inProgress: false,
    error: '',
}, action) {
    switch (action.type) {
        case RESET_PASS:
            return {
                error: '',
                inProgress: true,
            };
        case RESET_PASS_FAILURE:
            return {
                inProgress: false,
                error: 'No Active User Account associated with that email address.',
            };
        case RESET_PASS_SUCCESS:
        case CLEAR_RESET_PASS_ERROR:
            return {
                inProgress: false,
                error: '',
            };
        default:
            return state;
    }
}

export function loginModalOpened(state = false, action) {
    switch (action.type) {
        case OPEN_LOGIN_MODAL:
            return true;
        case GET_RACE:
        case CLOSE_LOGIN_MODAL:
            return false;
        default:
            return state;
    }
}

export function vipModalOpened(state = false, action) {
    switch (action.type) {
        case OPEN_VIP_MODAL:
            return true;
        case CLOSE_VIP_MODAL:
            return false;
        default:
            return state;
    }
}

export function activeLoginSection(state = 'login', action) {
    switch (action.type) {
        case OPEN_LOGIN_SECTION:
            return 'login';
        case OPEN_FORGOT_PASS_SECTION:
            return 'forgot_pass';
        case RESET_PASS_SUCCESS:
            return 'success_page';
        default:
            return state;
    }
}

export function landingData(state = defaultData, action) {
    switch (action.type) {
        case FETCH_THEME_SUCCESS:
            return {
                ...state,
                ...mapStateFromTheme(action.result),
                themeId: action.themeId,
            };
        default:
            return state;
    }
}

export function themeLoading(state = false, action) {
    switch (action.type) {
        case FETCH_THEME:
            return true;
        case FETCH_THEME_SUCCESS:
        case FETCH_THEME_FAILURE:
            return false;
        default:
            return state;
    }
}

export function endNyrrModalOpen(state = false, action) {
    switch (action.type) {
        case TOGGLE_END_NYRR_MODAL:
            return !state;
        default:
            return state;
    }
}

export function redirectToLanding(state = false, action) {
    switch (action.type) {
        case REDIRECT_TO_LANDING:
            return true;
        case CLEAR_REDIRECT_TO_LANDING:
            return false;
        default:
            return state;
    }
}

export default combineReducers({
    contactSuccessModal,
    plansModalOpened,
    loginModalOpened,
    activeLoginSection,
    vipModalOpened,
    landingData,
    themeLoading,
    resetPass: resetPassReducer,
    endNyrrModalOpen,
    redirectToLanding,
});

export const closeContactSuccessModal = () => ({
    type: CLOSE_CONTACT_SUCCESS_MODAL,
});

export const openPlansModal = () => ({
    type: OPEN_PLANS_MODAL,
});

export const closePlansModal = () => ({
    type: CLOSE_PLANS_MODAL,
});

export const openLoginModal = () => ({
    type: OPEN_LOGIN_MODAL,
});

export const closeLoginModal = () => ({
    type: CLOSE_LOGIN_MODAL,
});

export const openLoginSection = () => ({
    type: OPEN_LOGIN_SECTION,
});

export const openForgotPassSection = legacyRunner => ({
    type: OPEN_FORGOT_PASS_SECTION,
    legacyRunner,
});

export const openVipModal = () => ({
    type: OPEN_VIP_MODAL,
});

export const closeVipModal = () => ({
    type: CLOSE_VIP_MODAL,
});

export const clearResetPassError = () => ({
    type: CLEAR_RESET_PASS_ERROR,
});

export const toggleEndNyrrModal = () => ({
    type: TOGGLE_END_NYRR_MODAL,
});

export const forceRedirectToLanding = () => ({
    type: REDIRECT_TO_LANDING,
});

export const clearRedirectToLanding = () => ({
    type: CLEAR_REDIRECT_TO_LANDING,
});

export function* watchResetPassSuccess({ pathname }) {
    if (pathname.indexOf('signup') !== -1) { // from signup
        yield put(clearError('email'));
        return yield put(forceRedirectToLanding());
    }
    return null;
}

export function* rootSaga() {
    yield takeEvery(RESET_PASS_SUCCESS, watchResetPassSuccess);
}

export const resetPass = (body, pathname) => ({
    types: [RESET_PASS, RESET_PASS_SUCCESS, RESET_PASS_FAILURE],
    promise: () => fetch(`${process.env.RTAPI_URL}/API_resetblue.php`, {
        method: 'POST',
        body: prepareBody(body),
    }).then(res => res.json()),
    pathname,
});

export const landingContactUs = body => ({
    types: [LANDING_CONTACT_US, LANDING_CONTACT_US_SUCCESS, LANDING_CONTACT_US_FAILURE],
    promise: () => fetch(`${process.env.RTAPI_URL}/API_contact2.php`, {
        method: 'POST',
        body: prepareBody(body),
    }).then(res => res.json()),
});



/** WEBPACK FOOTER **
 ** ./src/redux/landing.js
 **/